import initiateNegotiation from './initiateNegotiation';
import round from './round';
import generateComparative from './generateComparative';
import XLSX from 'xlsx';
import UploadDocument from '@/app/components/onlineApproval/internalWorkFlow/history/uploadDocument';
import HistoryRecord from '@/app/components/onlineApproval/internalWorkFlow/history/historyRecord';
import ApprovalHistory from '@/app/components/onlineApproval/internalWorkFlow/history/approvalHistory';
import sendForApproval from '@/app/components/onlineApproval/internalWorkFlow/history/sendForApproval';

export default {
  name: 'negotiationRounds',
  props: [
    'negotiationAllData',
    'rfphdrid',
    'headerAllData',
    'menuFromDashboard'
  ],
  components: {
    initiateNegotiation,
    round,
    generateComparative,
    UploadDocument,
    HistoryRecord,
    ApprovalHistory,
    sendForApproval
  },
  data() {
    return {
      previousRound: -1,
      currentRound: 0,
      nextRound: 1,
      roundData: [],
      roundFields: [
        {
          key: 'negotiation_seq',
          label: 'Round',
          class: 'col-fix text-center'
        },
        {
          key: 'start_date',
          label: 'Initiation Date',
          class: 'col-fix text-center'
        },
        {
          key: 'end_date',
          class: 'col-fix text-center'
        },
        {
          key: 'round_close_date',
          label: 'Round Close Date',
          class: 'col-fix text-center'
        },
        {
          key: 'status',
          class: 'col-fix text-center'
        },
        {
          key: 'remarks',
          class: 'col-fix text-center'
        },

        {
          key: 'close_negotiation',
          class: 'col-fix text-center'
        }
      ],
      showOpenRoundsModal: false,
      showOpenInitiateModal: false,
      rfpHeaderId: null,
      vendorData: [],
      negotiationHdrId: null,
      roundProps: {},
      showOpenCloseNegotiationModal: false,
      selectedOption: '',
      roundIndex: null,
      remarks: null,
      autofocus: true,
      rfpLocationFlag: false,
      rfpItemFlag: false,
      rfpBoqFlag: false,
      rfpInitiateBidFlag: false,
      showOpenGenerateComparativeModal: false,
      roundStatus: null,
      rfpClosedFlag: false,
      itemBasis: null,
      negotiationSequence: null,
      showOpenNewGenerateComparativeModal: false,
      generateComparativeData: [],
      generateComparativeFields: [
        {
          key: 'location_name',
          label: 'Location',
          class: 'text-center'
        },
        {
          key: 'cost_centre',
          class: 'text-center'
        },

        {
          key: 'item_code',
          label: 'Item Code',
          class: 'text-center'
        },
        {
          key: 'item_description',
          class: 'text-center'
        },
        {
          key: 'quantity',
          label: 'Quantity',
          class: 'text-center'
        },
        {
          key: 'name',
          label: 'Vendor Name',
          class: 'text-center'
        },
        {
          key: 'negotiation_seq',
          label: 'Round',
          class: 'text-center'
        },
        {
          key: 'version',
          label: 'Version',
          class: 'text-center'
        },
        {
          key: 'unit_price',
          label: 'Price',
          class: 'text-center'
        },
        {
          key: 'attributes',
          label: 'Attributes',
          class: 'text-center'
        }
      ],
      popoverContent: null,
      rfpExtensionId: null,
      rfpBoqFilesFlag: false,
      showHistory: false,
      historyType: null,
      documentList: [],
      selectedGridData: {
        le_id: '67',
        le_name: 'Delhivery Limited',
        nfa_cat_vset: null,
        nfa_cat: null,
        nfa_sub_cat_vset: null,
        nfa_sub_cat: null
      },
      userId: null,
      roundFieldsComparative: [
        {
          key: 'negotiation_seq',
          label: 'Round',
          class: 'col-fix text-center'
        },
        {
          key: 'start_date',
          label: 'Initiation Date',
          class: 'col-fix text-center'
        },
        {
          key: 'end_date',
          class: 'col-fix text-center'
        },
        {
          key: 'status',
          class: 'col-fix text-center'
        },
        {
          key: 'remarks',
          class: 'col-fix text-center'
        },

        {
          key: 'close_negotiation',
          class: 'col-fix text-center'
        },
        {
          key: 'document',
          class: 'col-fix text-center'
        }
      ],
      showWorkflowHistory: false,
      selectedRfpDetails: {},
      workflowHistoryType: null,
      initiateNegotitionModal: true,
      boqComparativeApiData: [],
      itemComparativeApiData: [],
      checkvendorPresent:[]
    };
  },
  mounted() {
    this.checkvendorPresent = this.negotiationAllData;
    this.userId = this.$store.state.auth.userId;
    if (this.negotiationAllData && this.negotiationAllData.length > 0) {
      this.getParentToChildData(this.negotiationAllData);
      this.rfpInitiateBidFlag = true;
      if (
        (this.headerAllData &&
          this.headerAllData.approval_status === 'REJECTED') ||
        this.headerAllData.approval_status === 'DRAFT'
      ) {
        this.rfpInitiateBidFlag = false;
      }
      this.eventBus.$emit('rfpInitiateBidFlag', this.rfpInitiateBidFlag);
    }
    if (this.rfphdrid) {
      this.rfpHeaderId = this.rfphdrid;
    }
  },
  created() {
    this.eventBus.$on('vendorData', vendorData => {
      this.vendorData = vendorData;
    });
    this.eventBus.$on('rfpExtensionId', rfpExtensionId => {
      this.rfpExtensionId = rfpExtensionId;
      if (this.rfpExtensionId) {
        this.getAllRfpData();
      }
    });
    this.eventBus.$on('roundData', roundData => {
      this.roundData = roundData;
      if (this.roundData.length > 0) {
        this.rfpInitiateBidFlag = true;
        this.eventBus.$emit('rfpInitiateBidFlag', this.rfpInitiateBidFlag);
      }
      this.roundStatus = this.roundData[this.roundData.length - 1].status;
      this.eventBus.$emit('roundStatus', this.roundStatus);
      this.negotiationHdrId = roundData.negotiation_hdr_id;
    });
    this.eventBus.$on('rfpLocationFlag', rfpLocationFlag => {
      this.rfpLocationFlag = rfpLocationFlag;
    });
    this.eventBus.$on('rfpItemFlag', rfpItemFlag => {
      this.rfpItemFlag = rfpItemFlag;
    });
    this.eventBus.$on('rfpBoqFlag', rfpBoqFlag => {
      this.rfpBoqFlag = rfpBoqFlag;
    });
    this.eventBus.$on('rfpClosedFlag', rfpClosedFlag => {
      this.rfpClosedFlag = rfpClosedFlag;
    });
    this.eventBus.$on('itemBasis', rfpBasis => {
      this.itemBasis = rfpBasis;
      if (this.itemBasis === 'boqFiles') {
        this.roundFields = this.roundFieldsComparative;
      }
    });
    this.eventBus.$on('headerId', rfpHeaderId => {
      this.rfpHeaderId = rfpHeaderId;
    });
    this.eventBus.$on('rfpBoqFilesFlag', rfpBoqFilesFlag => {
      this.rfpBoqFilesFlag = rfpBoqFilesFlag;
    });
    this.eventBus.$on('initiateNegotitionModal', initiateNegotitionModal => {
      this.initiateNegotitionModal = initiateNegotitionModal;
      if (!this.initiateNegotitionModal) {
        this.initiateModal(false);
      }
    });
  },
  methods: {
    initiateRound() {
      this.nextRound++;
      this.previousRound++;
      this.currentRound++;
    },
    rowSelected(item) {
      this.negotiationSequence = item.negotiation_seq;
      this.roundProps = {
        negotiation_hdr_id: item.negotiation_hdr_id,
        rfp_header_id: item.rfp_header_id,
        status: item.status
      };
      this.showOpenRoundsModal = true;
    },
    roundsModal(flag) {
      this.showOpenRoundsModal = flag;
    },
    initiateModal(flag) {
      this.showOpenInitiateModal = flag;
    },
    initiateNegotiation() {
      if (this.vendorData.length === 0) {
        alert('Please add vendors first!');
      } else {
        this.showOpenInitiateModal = true;
      }
    },
    closeNegotiation(negotiationheaderid) {
      this.remarks = null;
      this.negotiationHdrId = negotiationheaderid;
      this.showOpenCloseNegotiationModal = true;
    },
    getParentToChildData(data) {
      this.roundData = data;
      for (let i of this.roundData) {
        i._rowVariant = 'info';
      }
      this.roundStatus = this.roundData[this.roundData.length - 1].status;
      this.eventBus.$emit('roundStatus', this.roundStatus);
    },
    closeNegotiationModal(flag, selected) {
      if (selected === 'yes') {
        if (this.remarks) {
          let payload = {
            negotiation_hdr_id: this.negotiationHdrId,
            remarks: this.remarks
          };
          this.loading = true;
          this.$store
            .dispatch('rfp/getStatus', payload)
            .then(response => {
              this.loading = false;
              if (response.status === 200) {
                this.makeToast(response.data.message, 'success');
                this.getAllRfpData();
              }
            })
            .catch(() => {
              this.loading = false;
            });
          this.showOpenCloseNegotiationModal = flag;
          this.autofocus = true;
        } else {
          alert('Please Enter Remarks first');
          this.autofocus = true;
        }
      } else {
        this.showOpenCloseNegotiationModal = flag;
      }
    },
    changeSelectedOption(option) {
      if (option === 'yes') {
        this.roundData[this.roundIndex].status = 'CLOSED';
        this.showOpenCloseNegotiationModal = false;
        this.$emit('getRfpAllData', this.rfpHeaderId);
      } else {
        this.showOpenCloseNegotiationModal = false;
      }
    },
    makeToast(content, variant) {
      this.$bvToast.toast(content, {
        title: 'Alert',
        variant: variant,
        solid: true,
        toaster: 'b-toaster-top-center',
        appendToast: true,
        toastClass: 'custom-toast',
        autoHideDelay: 2000
      });
    },
    getAllRfpData() {
      const payload = {
        headerId: this.rfpHeaderId
      };
      this.loading = true;
      this.$store
        .dispatch('rfp/getRfpDataByHeaderId', payload)
        .then(response => {
          this.loading = false;
          if (response.status === 200) {
            let result = response.data.data.rfp_negotiation_dtls;
            this.roundData = result;
            this.roundStatus = this.roundData[this.roundData.length - 1].status;
            this.eventBus.$emit('roundStatus', this.roundStatus);
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // openGenerateComparativeModal() {
    //   this.showOpenGenerateComparativeModal = true;
    // },
    // generateComparativeModal(flag) {
    //   this.showOpenGenerateComparativeModal = flag;
    // },
    generateNewComparativeModal(flag) {
      this.showOpenNewGenerateComparativeModal = flag;
    },
    openNewGenerativeModal() {
      this.generateComparativeData = [];
      this.showOpenNewGenerateComparativeModal = true;
    },
    getGenerateComparative() {
      this.generateComparativeData = [];
      if (this.itemBasis === 'item') {
        let payload = {
          rfp_header_id: this.rfpHeaderId
        };
        this.loading = true;
        this.$store
          .dispatch('rfp/getRfpComparativeForItemAllRounds', payload)
          .then(response => {
            this.loading = false;
            if (response.status === 200) {
              let result = response.data.data;
              this.generateComparativeData = result;
              this.itemComparativeApiData = result;
              this.processDataForItemDetail();
            }
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    getKeySummaryDtls(value) {
      const payload = {
        tag: value,
        menu_id: this.$store.state.shared.menuId
      };
      this.loader = true;
      this.$store
        .dispatch('rfp/getKeySummaryDtls', payload)
        .then(resp => {
          this.loader = false;
          this.helpModal = true;
          if (resp.status === 200) {
            let result = resp.data.data;
            this.popoverContent = result;
          } else {
            this.helpText = 'Something Went Wrong.';
          }
        })
        .catch(() => {
          this.helpModal = true;
          this.loader = false;
          this.helpText = 'Something Went Wrong.';
        });
    },
    downloadExcelData() {
      this.makeToast('Excel Sheet downloading!', 'success');
      const ws = XLSX.utils.json_to_sheet(this.generateComparativeData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Comparative');
      XLSX.writeFile(wb, 'comparative.xlsx');
    },
    getOpenKmAuthTokenUploadDocument(negHdrId) {
      this.negotiationHdrId = negHdrId;
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/openKmPartyPortalAuthenticate')
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.openKmAuth = response.data.data.token;
            if (this.openKmAuth) {
              this.showHideHistory(true, 'invoice', negHdrId);
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    showHideHistory(flag, historyType, negHdrId) {
      this.showHistory = flag;
      this.historyType = historyType;
      this.getUploadedDocDtl(negHdrId);
    },
    getUploadedDocDtl(negHdrId) {
      const payload = {
        _page: 0,
        _limit: 100,
        menu_id: this.$store.state.shared.menuId,
        sub_menu_id: 91,
        record_id: negHdrId
      };
      this.documentData = [];
      this.$store
        .dispatch('intWorkflow/getOpenKmDocDtl', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            if (response.data.data.page.length > 0) {
              const docList = response.data.data.page;
              this.documentList = response.data.data.page;
              this.documentData = docList.map(data => {
                data.file_size = this.formatBytes(data.file_size);
                return data;
              });
            } else {
              this.$emit('closeModal');
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    showHideWorkflowHistory(flag, historyType) {
      // to click initiate approval than visible button
      if (
        (this.selectedRfpDetails.approval_status === 'INPROCESS' ||
          this.selectedRfpDetails.approval_status === 'NOTREQUIRED' ||
          this.selectedRfpDetails.approval_status === 'APPROVED') &&
        historyType === 'uploadDocument'
      ) {
        alert('You Cannot Upload Document in this Stage');
      } else {
        this.showWorkflowHistory = flag;
        this.workflowHistoryType = historyType;
      }
    },
    getBoqComparative(type) {
      if (type === 'detail') {
        this.getBoqDetailComparative();
      } else if (type === 'grand') {
        this.getBoqGrandSummaryComparative();
      } else if (type === 'activityCode') {
        this.getBoqActivityCodeSummaryComparative();
      } else if (type === 'detailAllRounds') {
        this.getBoqDetailComparativeForAllRounds();
      }
    },
    getBoqDetailComparative() {
      let payload = {
        rfp_header_id: this.rfpHeaderId
      };
      this.loading = true;
      this.$store
        .dispatch('rfp/getBoqGenerateComparativeForAllRounds', payload)
        .then(response => {
          this.loading = false;
          if (response.status === 200) {
            let result = response.data.data;
            this.boqComparativeApiData = result;
            for (let i of this.boqComparativeApiData) {
              i.boq_quantity = Number(i.boq_quantity).toFixed(2);
            }
            this.processDataForDetail();
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //     processDataForDetail() { // 1.5 (Himanshu) Previous function commented
    //   this.generateComparativeFields = [
    //     {
    //       key: 'sheet_name',
    //       label: 'Sheet Name',
    //       class: 'narrow-col'
    //     },
    //     {
    //       key: 'r_number',
    //       label: 'Row No',
    //       class: 'narrow-col'
    //     },
    //     {
    //       key: 's_number',
    //       label: 'Serial No',
    //       class: 'narrow-col'
    //     },
    //     {
    //       key: 'location_name',
    //       label: 'Location',
    //       class: 'narrow-col'
    //     },
    //     {
    //       key: 'boq_line_code',
    //       label: 'Activity Code',
    //       class: ''
    //     },
    //     {
    //       key: 'boq_line_subcode',
    //       label: 'Subcode',
    //       class: ''
    //     },
    //     {
    //       key: 'boq_description',
    //       label: 'Description',
    //       class: 'col-fix-wrap'
    //     },
    //     {
    //       key: 'uom',
    //       label: 'UOM',
    //       class: 'narrow-col'
    //     },
    //     {
    //       key: 'boq_quantity',
    //       label: 'Quantity',
    //       class: 'text-right col-wrap'
    //     }
    //   ];

    //   let vendors = new Set();
    //   this.boqComparativeApiData.forEach(item => {
    //     item.vendor_unit_price_details.forEach(vendor => {
    //       vendors.add(vendor.vendor_name);
    //     });
    //   });

    //   vendors.forEach(vendor => {
    //     this.generateComparativeFields.push(
    //       {
    //         key: `${vendor}_unit_price`,
    //         label: `${vendor} Unit Price (INR)`,
    //         class: 'text-right col-wrap'
    //       },
    //       {
    //         key: `${vendor}_total_amount`,
    //         label: `${vendor} Total Amount`,
    //         class: 'text-right col-wrap'
    //       }
    //     );
    //   });

    //   let totalsRow = {
    //     sheet_name: 'Total',
    //     _rowVariant: 'info',
    //     rowClass: 'font-weight-bold'
    //   };

    //   this.generateComparativeData = this.boqComparativeApiData.map(item => {
    //     let row = { ...item };
    //     vendors.forEach(vendor => {
    //       let vendorData = item.vendor_unit_price_details.find(
    //         v => v.vendor_name === vendor
    //       );

    //       row[`${vendor}_unit_price`] =
    //         vendorData && vendorData.unit_price !== null
    //           ? `${Number(vendorData.unit_price).toFixed(2)} (Round - ${vendorData.negotiation_sequence})`
    //           : '-';

    //       row[`${vendor}_total_amount`] =
    //         vendorData && vendorData.total_amount !== null
    //           ? `${Number(vendorData.total_amount).toFixed(2)}`
    //           : '-';

    //       totalsRow[`${vendor}_total_amount`] =
    //         (totalsRow[`${vendor}_total_amount`] || 0) +
    //         (vendorData && vendorData.total_amount !== null
    //           ? Number(vendorData.total_amount)
    //           : 0);
    //     });

    //     return row;
    //   });

    //   vendors.forEach(vendor => {
    //     if (totalsRow[`${vendor}_total_amount`] !== undefined) {
    //       totalsRow[`${vendor}_total_amount`] = `${totalsRow[
    //         `${vendor}_total_amount`
    //       ].toFixed(2)}`;
    //     }
    //     // No round for totals row
    //     totalsRow[`${vendor}_unit_price`] = '-';
    //   });

    //   this.generateComparativeData.push(totalsRow);
    // },
    processDataForDetail() {
      // 1.5 (Himanshu) new function added for latest bid
      this.generateComparativeFields = [
        {
          key: 'sheet_name',
          label: 'Sheet Name',
          class: 'narrow-col'
        },
        {
          key: 'r_number',
          label: 'Row No',
          class: 'narrow-col'
        },
        {
          key: 's_number',
          label: 'Serial No',
          class: 'narrow-col'
        },
        {
          key: 'location_name',
          label: 'Location',
          class: 'narrow-col'
        },
        {
          key: 'boq_line_code',
          label: 'Activity Code',
          class: ''
        },
        {
          key: 'boq_line_subcode',
          label: 'Subcode',
          class: ''
        },
        {
          key: 'boq_description',
          label: 'Description',
          class: 'col-fix-wrap'
        },
        {
          key: 'uom',
          label: 'UOM',
          class: 'narrow-col'
        },
        {
          key: 'boq_quantity',
          label: 'Quantity',
          class: 'text-right col-wrap'
        }
      ];

      let vendors = new Set();
      this.boqComparativeApiData.forEach(item => {
        item.vendor_unit_price_details.forEach(vendor => {
          vendors.add(vendor.vendor_name);
        });
      });

      let vendorRounds = {};
      this.boqComparativeApiData.forEach(item => {
        item.vendor_unit_price_details.forEach(vendor => {
          if (!vendorRounds[vendor.vendor_name]) {
            vendorRounds[vendor.vendor_name] = vendor.negotiation_sequence;
          } else if (
            vendor.negotiation_sequence > vendorRounds[vendor.vendor_name]
          ) {
            vendorRounds[vendor.vendor_name] = vendor.negotiation_sequence;
          }
        });
      });

      vendors.forEach(vendor => {
        const roundLabel = vendorRounds[vendor]
          ? ` (Round - ${vendorRounds[vendor]})`
          : '';
        this.generateComparativeFields.push(
          {
            key: `${vendor}_unit_price`,
            label: `${vendor} Unit Price (INR)${roundLabel}`,
            class: 'text-right col-wrap'
          },
          {
            key: `${vendor}_total_amount`,
            label: `${vendor} Total Amount`,
            class: 'text-right col-wrap'
          }
        );
      });

      let totalsRow = {
        sheet_name: 'Total',
        _rowVariant: 'info',
        rowClass: 'font-weight-bold'
      };

      this.generateComparativeData = this.boqComparativeApiData.map(item => {
        let row = { ...item };
        vendors.forEach(vendor => {
          let vendorData = item.vendor_unit_price_details.find(
            v => v.vendor_name === vendor
          );

          row[`${vendor}_unit_price`] =
            vendorData && vendorData.unit_price !== null
              ? Number(vendorData.unit_price).toFixed(2)
              : '-';

          row[`${vendor}_total_amount`] =
            vendorData && vendorData.total_amount !== null
              ? Number(vendorData.total_amount).toFixed(2)
              : '-';

          totalsRow[`${vendor}_total_amount`] =
            (totalsRow[`${vendor}_total_amount`] || 0) +
            (vendorData && vendorData.total_amount !== null
              ? Number(vendorData.total_amount)
              : 0);
        });

        return row;
      });

      vendors.forEach(vendor => {
        if (totalsRow[`${vendor}_total_amount`] !== undefined) {
          totalsRow[`${vendor}_total_amount`] = `${totalsRow[
            `${vendor}_total_amount`
          ].toFixed(2)}`;
        }
        totalsRow[`${vendor}_unit_price`] = '-';
      });

      this.generateComparativeData.push(totalsRow);
    },

    getBoqGrandSummaryComparative() {
      const payload = {
        rfp_header_id: this.rfpHeaderId
      };
      // this.loading = true;
      this.$store
        .dispatch('rfp/getGenerateComparativeData', payload)
        .then(response => {
          this.loading = false;
          if (response.status === 200) {
            let result = response.data.data;
            this.boqComparativeApiData = result;
            this.comparativeSheetData();
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // comparativeSheetData() { // 1.4 (Himanshu) commented for a new function
    //   this.generateComparativeData = [];
    //   this.generateComparativeFields = [
    //     { key: 'sheet_name', label: 'Sheet Name', class: 'text-center' }
    //   ];
    //   let vendorNames = new Set();
    //   let totalsRow = { sheet_name: 'Total', _rowVariant: 'info' };
    //   let vendorTotals = [];
    //   this.boqComparativeApiData.forEach(sheet => {
    //     sheet.vendor_details.forEach(vendor => {
    //       vendorNames.add(vendor.vendor_name);
    //     });
    //   });
    //   let vendorArray = Array.from(vendorNames);
    //   vendorArray.forEach(vendor => {
    //     this.generateComparativeFields.push({
    //       key: vendor,
    //       label: `${vendor} Total Amount`,
    //       class: 'text-right nowrap-column'
    //     });
    //     totalsRow[vendor] = 0;
    //   });
    //   this.boqComparativeApiData.forEach(sheet => {
    //     let row = { sheet_name: sheet.sheet_name };
    //     vendorArray.forEach(vendor => {
    //       let vendorData = sheet.vendor_details.find(
    //         v => v.vendor_name === vendor
    //       );
    //       let totalAmount =
    //         vendorData && vendorData.total_amount !== null
    //           ? Number(vendorData.total_amount)
    //           : 0;
    //       row[vendor] =
    //         vendorData && vendorData.total_amount !== null
    //           ? `₹${totalAmount.toFixed(2)} (Round - ${
    //               vendorData.negotiation_sequence
    //             })`
    //           : 'N/A';
    //       totalsRow[vendor] += totalAmount;
    //     });
    //     this.generateComparativeData.push(row);
    //   });
    //   vendorArray.forEach(vendor => {
    //     let total = totalsRow[vendor];
    //     totalsRow[vendor] = `₹${total.toFixed(2)}`;
    //     vendorTotals.push({
    //       vendor,
    //       total: total
    //     });
    //   });
    //   this.generateComparativeData.push(totalsRow);
    //   // this.getLevels(vendorTotals);
    // },
    //     comparativeSheetData() { // 1.4 (Himanshu) new function for comparativeSheetData // 1.5 (Himanshu) previous function commented for Grand Summary
    //   this.generateComparativeData = [];
    //   this.generateComparativeFields = [
    //     { key: 'sheet_name', label: 'Sheet Name', class: 'text-center min-w-150' }
    //   ];
    //   let vendorNames = new Set();
    //   let totalsRow = { sheet_name: 'Total', _rowVariant: 'info' };
    //   let vendorTotals = [];
    //   this.boqComparativeApiData.forEach(sheet => {
    //     sheet.vendor_details.forEach(vendor => {
    //       vendorNames.add(vendor.vendor_name);
    //     });
    //   });
    //   let vendorArray = Array.from(vendorNames);
    //   vendorArray.forEach(vendor => {
    //     this.generateComparativeFields.push({
    //       key: vendor,
    //       label: `${vendor} Total Amount`,
    //       class: 'text-right nowrap-column min-w-200'
    //     });

    //     this.generateComparativeFields.push({
    //       key: vendor + "_cost_per_area",
    //       label: `${vendor} Cost/Area`,
    //       class: 'text-right nowrap-column min-w-180'
    //     });
    //     totalsRow[vendor] = null;
    //     totalsRow[vendor + "_cost_per_area"] = null;
    //   });
    //   this.boqComparativeApiData.forEach(sheet => {
    //     let row = { sheet_name: sheet.sheet_name };

    //     vendorArray.forEach(vendor => {
    //       let vendorData = sheet.vendor_details.find(
    //         v => v.vendor_name === vendor
    //       );
    //       let totalAmount =
    //         vendorData && vendorData.total_amount !== null
    //           ? Number(vendorData.total_amount)
    //           : null;
    //       row[vendor] =
    //         totalAmount !== null
    //           ? `₹${totalAmount.toFixed(2)} (Round - ${vendorData.negotiation_sequence})`
    //           : null;
    //       let costPerArea =
    //         vendorData && vendorData.cost_per_area_sheetwise !== null
    //           ? Number(vendorData.cost_per_area_sheetwise)
    //           : null;
    //       row[vendor + "_cost_per_area"] =
    //         costPerArea !== null ? costPerArea.toFixed(2) : null;
    //       if (totalAmount !== null) {
    //         totalsRow[vendor] =
    //           totalsRow[vendor] !== null
    //             ? totalsRow[vendor] + totalAmount
    //             : totalAmount;
    //       }
    //       if (costPerArea !== null) {
    //         totalsRow[vendor + "_cost_per_area"] =
    //           totalsRow[vendor + "_cost_per_area"] !== null
    //             ? totalsRow[vendor + "_cost_per_area"] + costPerArea
    //             : costPerArea;
    //       }
    //     });
    //     this.generateComparativeData.push(row);
    //   });
    //   vendorArray.forEach(vendor => {
    //     totalsRow[vendor] =
    //       totalsRow[vendor] !== null ? `₹${totalsRow[vendor].toFixed(2)}` : null;
    //     totalsRow[vendor + "_cost_per_area"] =
    //       totalsRow[vendor + "_cost_per_area"] !== null
    //         ? totalsRow[vendor + "_cost_per_area"].toFixed(2)
    //         : null;
    //     vendorTotals.push({
    //       vendor,
    //       total: totalsRow[vendor]
    //     });
    //   });

    //   this.generateComparativeData.push(totalsRow);
    // },
    comparativeSheetData() {
      // 1.5 (Himanshu) new function for comparativeSheetData
      this.generateComparativeData = [];
      this.generateComparativeFields = [
        {
          key: 'sheet_name',
          label: 'Sheet Name',
          class: 'text-center min-w-150'
        }
      ];

      let vendorNames = new Set();
      let totalsRow = { sheet_name: 'Total', _rowVariant: 'info' };
      let vendorTotals = [];
      this.boqComparativeApiData.forEach(sheet => {
        sheet.vendor_details.forEach(vendor => {
          vendorNames.add(vendor.vendor_name);
        });
      });

      let vendorArray = Array.from(vendorNames);
      let vendorRounds = {};
      this.boqComparativeApiData.forEach(sheet => {
        sheet.vendor_details.forEach(vendor => {
          if (!vendorRounds[vendor.vendor_name]) {
            vendorRounds[vendor.vendor_name] = vendor.negotiation_sequence;
          } else if (
            vendor.negotiation_sequence > vendorRounds[vendor.vendor_name]
          ) {
            vendorRounds[vendor.vendor_name] = vendor.negotiation_sequence;
          }
        });
      });
      vendorArray.forEach(vendor => {
        const roundLabel = vendorRounds[vendor]
          ? ` (Round - ${vendorRounds[vendor]})`
          : '';

        this.generateComparativeFields.push({
          key: vendor,
          label: `${vendor} Total Amount${roundLabel}`,
          class: 'text-right min-w-200'
        });

        this.generateComparativeFields.push({
          key: vendor + '_cost_per_area',
          label: `${vendor} Cost/Area`,
          class: 'text-right min-w-180'
        });

        totalsRow[vendor] = null;
        totalsRow[vendor + '_cost_per_area'] = null;
      });
      this.boqComparativeApiData.forEach(sheet => {
        let row = { sheet_name: sheet.sheet_name };

        vendorArray.forEach(vendor => {
          let vendorData = sheet.vendor_details.find(
            v => v.vendor_name === vendor
          );

          let totalAmount =
            vendorData && vendorData.total_amount !== null
              ? Number(vendorData.total_amount)
              : null;
          row[vendor] =
            totalAmount !== null ? `₹${totalAmount.toFixed(2)}` : null;

          let costPerArea =
            vendorData && vendorData.cost_per_area_sheetwise !== null
              ? Number(vendorData.cost_per_area_sheetwise)
              : null;
          row[vendor + '_cost_per_area'] =
            costPerArea !== null ? costPerArea.toFixed(2) : null;
          if (totalAmount !== null) {
            totalsRow[vendor] =
              totalsRow[vendor] !== null
                ? totalsRow[vendor] + totalAmount
                : totalAmount;
          }
          if (costPerArea !== null) {
            totalsRow[vendor + '_cost_per_area'] =
              totalsRow[vendor + '_cost_per_area'] !== null
                ? totalsRow[vendor + '_cost_per_area'] + costPerArea
                : costPerArea;
          }
        });

        this.generateComparativeData.push(row);
      });

      vendorArray.forEach(vendor => {
        totalsRow[vendor] =
          totalsRow[vendor] !== null
            ? `₹${totalsRow[vendor].toFixed(2)}`
            : null;
        totalsRow[vendor + '_cost_per_area'] =
          totalsRow[vendor + '_cost_per_area'] !== null
            ? totalsRow[vendor + '_cost_per_area'].toFixed(2)
            : null;

        vendorTotals.push({
          vendor,
          total: totalsRow[vendor]
        });
      });

      this.generateComparativeData.push(totalsRow);
    },
    getBoqActivityCodeSummaryComparative() {
      let payload = {
        rfp_header_id: this.rfpHeaderId
      };
      this.loading = true;
      this.$store
        .dispatch('rfp/getActivityCodeSummaryComparativeForAllRounds', payload)
        .then(response => {
          this.loading = false;
          if (response.status === 200) {
            let result = response.data.data;
            this.boqComparativeApiData = result;
            this.processDataForActivityCodeSummary();
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    processDataForActivityCodeSummary() {
      this.generateComparativeData = [];
      this.generateComparativeFields = [
        { key: 'sheet_name', label: 'Sheet Name', class: '' },
        { key: 'boq_line_code', label: 'Activity Code', class: '' }
      ];

      let vendorNames = new Set();
      let totalsRow = {
        sheet_name: 'Total',
        boq_line_code: '-',
        _rowVariant: 'info'
      };
      this.boqComparativeApiData.forEach(sheet => {
        sheet.vendor_details_summ_comp.forEach(vendor => {
          vendorNames.add(vendor.vendor_name);
        });
      });
      let vendorArray = Array.from(vendorNames);
      vendorArray.forEach(vendor => {
        this.generateComparativeFields.push({
          key: vendor,
          label: `${vendor} 
          Total Amount (INR)`,
          class: 'text-right'
        });
        totalsRow[vendor] = 0;
      });
      this.boqComparativeApiData.forEach(sheet => {
        let row = {
          sheet_name: sheet.sheet_name,
          boq_line_code: sheet.boq_line_code
        };
        vendorArray.forEach(vendor => {
          let vendorData = sheet.vendor_details_summ_comp.find(
            v => v.vendor_name === vendor
          );
          let totalAmount = vendorData ? Number(vendorData.total_amount) : 0;

          row[vendor] = `${totalAmount.toFixed(2)}`;
          totalsRow[vendor] += totalAmount;
        });
        this.generateComparativeData.push(row);
      });
      vendorArray.forEach(vendor => {
        totalsRow[vendor] = `${totalsRow[vendor].toFixed(2)}`;
      });
      this.generateComparativeData.push(totalsRow);
    },
    processDataForItemDetail() {
      this.generateComparativeFields = [
        {
          key: 'item_code',
          label: 'Item Code'
        },
        {
          key: 'item_description',
          label: 'Item Description'
        },
        {
          key: 'item_long_description',
          label: 'Item Specification'
        },
        {
          key: 'location_name',
          label: 'Location'
        },
        {
          key: 'negotiation_seq',
          label: 'Round'
        },
        {
          key: 'quantity',
          label: 'Quantity',
          class: 'narrow-col'
        },
        {
          key: 'uom',
          label: 'UOM',
          class: 'narrow-col'
        }
      ];
      let vendors = new Set();
      this.itemComparativeApiData.forEach(item => {
        item.vendor_unit_price_details.forEach(vendor => {
          vendors.add(vendor.vendor_name);
        });
      });
      vendors.forEach(vendor => {
        this.generateComparativeFields.push(
          {
            key: `${vendor}_unit_price`,
            label: `${vendor} Unit Price (INR)`,
            class: 'text-right col-wrap'
          },
          {
            key: `${vendor}_total_amount`,
            label: `${vendor} Total Amount`,
            class: 'text-right col-wrap'
          },
          {
            key: `${vendor}_vendor_attributes`,
            label: `${vendor} Vendor Attributes`,
            class: 'text-right col-wrap'
          }
        );
      });
      let totalsRow = {
        sheet_name: 'Total',
        _rowVariant: 'info',
        rowClass: 'font-weight-bold'
      };
      this.generateComparativeData = this.itemComparativeApiData.map(item => {
        let row = { ...item };
        vendors.forEach(vendor => {
          let vendorData = item.vendor_unit_price_details.find(
            v => v.vendor_name === vendor
          );
          row[`${vendor}_unit_price`] = vendorData
            ? `${Number(vendorData.unit_price).toFixed(2)}`
            : '-';
          row[`${vendor}_vendor_attributes`] = vendorData
            ? `${vendorData.vendor_attributes}`
            : '-';
          row[`${vendor}_total_amount`] = vendorData
            ? `${Number(vendorData.total_amount).toFixed(2)}`
            : '-';
          totalsRow[`${vendor}_total_amount`] =
            (totalsRow[`${vendor}_total_amount`] || 0) +
            (vendorData ? Number(vendorData.total_amount) : 0);
        });

        return row;
      });
      vendors.forEach(vendor => {
        if (totalsRow[`${vendor}_total_amount`] !== undefined) {
          totalsRow[`${vendor}_total_amount`] = `${totalsRow[
            `${vendor}_total_amount`
          ].toFixed(2)}`;
        }
      });
      this.generateComparativeData.push(totalsRow);
    },
    getBoqDetailComparativeForAllRounds() {
      let payload = {
        rfp_header_id: this.rfpHeaderId
      };
      this.loading = true;
      this.$store
        .dispatch('rfp/getBoqComparativeForAllRounds', payload)
        .then(response => {
          this.loading = false;
          if (response.status === 200) {
            let result = response.data.data;
            this.boqComparativeApiData = result;
            for (let i of this.boqComparativeApiData) {
              i.boq_quantity = Number(i.boq_quantity).toFixed(2);
            }
            this.processDataForDetailAllRounds();
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // processDataForDetailAllRounds() {
    //   this.generateComparativeFields = [
    //     {
    //       key: 'sheet_name',
    //       label: 'Sheet Name',
    //       class: 'narrow-col'
    //     },
    //     {
    //       key: 'r_number',
    //       label: 'Row No',
    //       class: 'narrow-col'
    //     },
    //     {
    //       key: 's_number',
    //       label: 'Serial No',
    //       class: 'narrow-col'
    //     },
    //     {
    //       key: 'negotiation_seq',
    //       label: 'Round',
    //       class: 'narrow-col'
    //     },
    //     {
    //       key: 'location_name',
    //       label: 'Location',
    //       class: 'narrow-col'
    //     },
    //     {
    //       key: 'boq_line_code',
    //       label: 'Activity Code',
    //       class: ''
    //     },
    //     {
    //       key: 'boq_line_subcode',
    //       label: 'Subcode',
    //       class: ''
    //     },
    //     {
    //       key: 'boq_description',
    //       label: 'Description',
    //       class: 'col-fix-wrap'
    //     },
    //     {
    //       key: 'uom',
    //       label: 'UOM',
    //       class: 'narrow-col'
    //     },
    //     {
    //       key: 'boq_quantity',
    //       label: 'Quantity',
    //       class: 'text-right col-wrap'
    //     }
    //   ];
    //   let vendors = new Set();
    //   this.boqComparativeApiData.forEach(item => {
    //     item.vendor_unit_price_details.forEach(vendor => {
    //       vendors.add(vendor.vendor_name);
    //     });
    //   });
    //   vendors.forEach(vendor => {
    //     this.generateComparativeFields.push(
    //       {
    //         key: `${vendor}_unit_price`,
    //         label: `${vendor} Unit Price (INR)`,
    //         class: 'text-right col-wrap'
    //       },
    //       {
    //         key: `${vendor}_total_amount`,
    //         label: `${vendor} Total Amount`,
    //         class: 'text-right col-wrap'
    //       }
    //     );
    //   });
    //   let totalsRow = {
    //     sheet_name: 'Total',
    //     _rowVariant: 'info',
    //     rowClass: 'font-weight-bold'
    //   };
    //   this.generateComparativeData = this.boqComparativeApiData.map(item => {
    //     let row = { ...item };
    //     vendors.forEach(vendor => {
    //       let vendorData = item.vendor_unit_price_details.find(
    //         v => v.vendor_name === vendor
    //       );
    //       row[`${vendor}_unit_price`] = vendorData
    //         ? `${Number(vendorData.unit_price).toFixed(2)}`
    //         : '-';

    //       row[`${vendor}_total_amount`] = vendorData
    //         ? `${Number(vendorData.total_amount).toFixed(2)}`
    //         : '-';
    //       totalsRow[`${vendor}_total_amount`] =
    //         (totalsRow[`${vendor}_total_amount`] || 0) +
    //         (vendorData ? Number(vendorData.total_amount) : 0);
    //     });

    //     return row;
    //   });
    //   vendors.forEach(vendor => {
    //     if (totalsRow[`${vendor}_total_amount`] !== undefined) {
    //       totalsRow[`${vendor}_total_amount`] = `${totalsRow[
    //         `${vendor}_total_amount`
    //       ].toFixed(2)}`;
    //     }
    //   });
    //   this.generateComparativeData.push(totalsRow);
    // }
   processDataForDetailAllRounds() {

  this.generateComparativeFields = [
    { key: 'sheet_name', label: 'Sheet Name', class: 'narrow-col' },
    { key: 'r_number', label: 'Row No', class: 'narrow-col' },
    { key: 's_number', label: 'Serial No', class: 'narrow-col' },
    { key: 'negotiation_seq', label: 'Round', class: 'narrow-col' },
    { key: 'location_name', label: 'Location', class: 'narrow-col' },
    { key: 'boq_line_code', label: 'Activity Code' },
    { key: 'boq_line_subcode', label: 'Subcode' },
    { key: 'boq_description', label: 'Description', class: 'col-fix-wrap' },
    { key: 'uom', label: 'UOM', class: 'narrow-col' },
    { key: 'boq_quantity', label: 'Quantity', class: 'text-right col-wrap' }
  ];

  let vendors = new Set();

  this.boqComparativeApiData.forEach(item => {
    item.vendor_unit_price_details.forEach(vendor => {
      vendors.add(vendor.vendor_name);
    });
  });

  vendors.forEach(vendor => {
    this.generateComparativeFields.push(
      {
        key: `${vendor}_unit_price`,
        label: `${vendor} Unit Price (INR)`,
        class: 'text-right col-wrap'
      },
      {
        key: `${vendor}_total_amount`,
        label: `${vendor} Total Amount`,
        class: 'text-right col-wrap'
      }
    );
  });

  let roundTotals = {};
  let finalData = [];

  this.boqComparativeApiData.forEach(item => {

    let row = { ...item };
    let round = item.negotiation_seq;

    if (!roundTotals[round]) {
      roundTotals[round] = {};
    }

    vendors.forEach(vendor => {

      let vendorData = item.vendor_unit_price_details.find(
        v => v.vendor_name === vendor
      );

      let totalAmount = vendorData ? Number(vendorData.total_amount) : 0;

      row[`${vendor}_unit_price`] = vendorData
        ? Number(vendorData.unit_price).toFixed(2)
        : '-';

      row[`${vendor}_total_amount`] = vendorData
        ? totalAmount.toFixed(2)
        : '-';

      if (!roundTotals[round][vendor]) {
        roundTotals[round][vendor] = 0;
      }

      roundTotals[round][vendor] += totalAmount;

    });

    finalData.push(row);

  });
  Object.keys(roundTotals).forEach(round => {

    let totalsRow = {
      sheet_name: `Total (Round ${round})`,
      negotiation_seq: round,
      _rowVariant: 'info',
      rowClass: 'font-weight-bold'
    };

    vendors.forEach(vendor => {
      totalsRow[`${vendor}_unit_price`] = '-';
      totalsRow[`${vendor}_total_amount`] =
        roundTotals[round][vendor].toFixed(2);
    });

    finalData.push(totalsRow);

  });
this.generateComparativeData = finalData;

}

  },
  beforeDestroy() {
    this.eventBus.$off('vendors');
    this.eventBus.$off('rfpInitiateBidFlag');
    this.eventBus.$off('roundStatus');
    this.eventBus.$off('rfpExtensionId');
  }
};
